import BasePage from '../../components/base-page/base-page';
import BlogSearch from '../../components/search/search';
import Share from '../../../shared/utils/share/share';
import SideScrollingBanner from '../../components/side-scrolling-banner/side-scrolling-banner';
import BlogSubscribeBanner from '../../components/blog-subscribe-banner/blog-subscribe-banner';
import defineBlogAppBannerElement from '../../components/blog-app-banner/blog-app-banner';
import defineWebAssistantPopup from '../../components/web-assistant-popup/web-assistant-popup';
import GoUpButton from '../../components/go-up-button/go-up-button';
import Carousel from '../../components/carousel/carousel';

import breakpoints from '../../config/breakpoints';

import analytics, { events } from '../../../shared/analytics';

import './post.scss';

class PostPage extends BasePage {
  ui = {
    articleTitle: '.js-article-title',
    searchInput: '.js-search-input',
    goUpButton: '.js-go-up-button',
    sliderBanner: '.js-slider-banner',
    subscribeBanner: '.js-subscribe-banner',
  };

  uiCollections = {
    contentBannerButton: '.js-promo-banner-cta',
    appBannerButton: 'blog-app-banner',
    useCaseBannerLink: '.use-case-banner a', // choose all links inside use-case-banner that's created on blog
    sliderBannerButton: '.js-slider-banner-cta',
    sliderBannerApp: '.slider-banner-slide',
  };

  events = {
    'click @uiCollections.contentBannerButton': 'handleContentBannerButtonClick',
    'click @uiCollections.appBannerButton': 'handleAppBannerButtonClick',
    'click @uiCollections.useCaseBannerLink': 'handleUseCaseBannerLinkClick',
    'click @uiCollections.sliderBannerButton': 'handleSliderBannerButtonClick',
    'click @uiCollections.sliderBannerApp': 'handleSliderBannerAppClick',
  };

  onInit() {
    super.onInit();

    if (this.ui.searchInput) {
      new BlogSearch().init();
    }

    new Share().init();
    new SideScrollingBanner().init();

    if (this.ui.subscribeBanner) {
      new BlogSubscribeBanner({ rootElement: '.js-subscribe-banner' }).init();
    }

    if (this.ui.goUpButton) {
      new GoUpButton(this.ui.articleTitle).init();
    }

    defineBlogAppBannerElement();
    defineWebAssistantPopup();

    if (this.ui.sliderBanner) {
      this.sliderBanner = new Carousel({
        rootElement: this.ui.sliderBanner,
        slidesPerPage: {
          [breakpoints.sm]: 3,
        },
      });
      this.sliderBanner.init();
    }
  }

  handleSliderBannerButtonClick = (e) => {
    e.preventDefault();
    const eventValue = e.target.closest('aside').className;

    this.signupModal.open();

    analytics.trackEvent({
      ...events.BLOG_BANNER_CLICK,
      eventLabel: 'Try free',
      eventLabel2: 'Slider apps banner',
      eventValue,
    });
  };

  handleSliderBannerAppClick = (e) => {
    const eventValue = e.target.closest('aside').className;
    const eventLabel = e.currentTarget.id;

    analytics.trackEvent({
      ...events.BLOG_BANNER_CLICK,
      eventLabel,
      eventLabel2: 'Slider apps banner',
      eventValue,
    });
  };

  handleContentBannerButtonClick = (e) => {
    e.preventDefault();

    const banner = e.target.closest('.promo-banner, .promo-new-banner');
    const bannerHeader = banner?.querySelector('.promo-banner__description-header, .promo-new-banner__description-header');
    const { textContent: eventLabel } = bannerHeader;

    this.signupModal.open();

    analytics.trackEvent({
      ...events.BLOG_BANNER_CLICK,
      eventLabel,
      eventLabel2: 'promo-banner',
    });
  };

  handleAppBannerButtonClick = (e) => {
    const eventLabel = e.currentTarget.getAttribute('name');

    analytics.trackEvent({
      ...events.BLOG_BANNER_CLICK,
      eventLabel,
      eventLabel2: 'app-banner',
    });
  };

  handleUseCaseBannerLinkClick = (e) => {
    const { textContent: eventLabel } = e.currentTarget;

    analytics.trackEvent({
      ...events.BLOG_BANNER_CLICK,
      eventLabel,
      eventLabel2: 'use-case-banner',
    });
  };
}

export default PostPage;

PostPage.initOnDomLoaded();
